// front_dock/src/lib/api.js
import axios from "axios";

/**
 * Producción: usamos el proxy del Nginx del frontend:
 *   /api  ->  backend:5000/api/
 *
 * Esto evita:
 * - CORS
 * - ERR_SSL_PROTOCOL_ERROR (por intentar https://HOST:5000)
 */
export const API_BASE = `${window.location.origin}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Opcional: interceptor para loguear errores y tener trazas más claras
api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error("[API error]", {
      url: err?.config?.url,
      method: err?.config?.method,
      baseURL: err?.config?.baseURL,
      message: err?.message,
      status: err?.response?.status,
      data: err?.response?.data,
    });
    return Promise.reject(err);
  }
);

export const getClienteEmbarcacionesHistorial = (clienteId) =>
  api.get(`/clientes/${clienteId}/embarcaciones/historial`);
